import React from 'react';
import ReactDOM from 'react-dom';
import { fetchData } from '../../helpers/base_data_fetcher';
import ExampleAdModal from './components/ExampleAdModal';

const mountElement = document.getElementById('adExamples');

export default function exampleAdvertModal(postBoldAd) {
  if (mountElement) {
    Promise.all([
      fetchData('site'),
      fetchData('customer'),
      fetchData('page'),
      fetchData('localisations'),
    ]).then(([site, customer, page, localisations]) => {
      ReactDOM.render(
        <ExampleAdModal
          currencySymbol={site.currency_symbol}
          isMobile={site.mobile}
          siteId={site.id}
          userType={customer.initial_type === 'seeker' ? 'seeker' : 'offerer'}
          subDirectory={site.sub_dir}
          loginReturnPath={page.loginReturnPath}
          postBoldAd={postBoldAd}
          localisations={localisations.upgrade}
        />,
        mountElement,
      );
    });
  }
}
